import type { ImageItem } from "@editor/items/image/ImageItem";
import type { ItemStoreState } from "@editor/items/ItemStore";
import type { ModelState } from "@editor/items/model/ModelState";
import type { StoreItem } from "@editor/items/StoreItem";

export default {
  applyToVersions: "<2.6.1",
  type: "before",
  name: "move all ids to unique ids",
  migrate(data: Partial<ModelState> & { images?: ItemStoreState<ImageItem> }) {
    addIdPrefixes(data.areas, "area");
    addIdPrefixes(data.conditions, "condition");
    addIdPrefixes(data.effects, "effect");
    addIdPrefixes(data.elements, "element");
    addIdPrefixes(data.elementMomentums, "elementMomentum");
    addIdPrefixes(data.images, "image");
    addIdPrefixes(data.incidents, "incident");
    addIdPrefixes(data.incidentTriggers, "incidentTrigger");
    addIdPrefixes(data.indicators, "indicator");
    addIdPrefixes(data.measures, "measure");
    addIdPrefixes(data.relations, "relation");
    addIdPrefixes(data.resources, "resource");
    addIdPrefixes(data.scenarios, "scenario");
    addIdPrefixes(data.scenarioEnds, "scenarioEnd");
    addIdPrefixes(data.simulations, "simulation");
    addIdPrefixes(data.stakeholders, "stakeholder");
    addIdPrefixes(data.templates, "template");
    addIdPrefixes(data.ways, "way");

    return data;
  }
};

function addIdPrefixes<T extends StoreItem>(
  storeData: ItemStoreState<T> | undefined,
  type: string | undefined
) {
  if (storeData == null) return;
  if (type == null) return;
  if (type == "") return;
  if (storeData.items == null) return;

  const ids = Object.keys(storeData.items);

  for (const id of ids) {
    const item = storeData.items[parseInt(id)];
    const newId = addPrefix<string>(type, id);
    item.uid = newId;
  }
}

function addPrefix<T extends string | undefined | null>(
  prefix: string | undefined,
  id: T
) {
  if (id == null) return id;
  if (prefix == null) return id;
  if (typeof id == "string" && id.startsWith(prefix)) return id;
  return `${prefix}_${id}`;
}
